import Big from 'big.js';
import {toString} from './num';

export const calcValueBalanceUtils = {
  getBalanceEv(valueEv, priceEv, valueFactor = 1e8, priceFactor = 1e4, balanceFactor = 1e8, rm = 0) {
    if (valueEv === 0) {
      return 0;
    }
    const factor = Big(balanceFactor).times(priceFactor).div(valueFactor);
    return Number(toString(Big(valueEv).div(priceEv).times(factor)));
  },
  /**
   *
   * @param {*} valueEv
   * @param {*} priceEv
   * @param {*} valueFactor
   * @param {*} precision 小数位数，0 到 1e+6（含）
   * @param {*} rm 舍入模式：0（向下）、1（半向上）、2（半偶数）或 3（向上）。
   * @returns
   */
  getBalanceRv(valueEv, priceEv, valueFactor = 1e8, priceFactor = 1e4, precision = 8, rm = 0) {
    if (valueEv === 0) {
      return Big(0).toFixed(precision, rm);
    }
    const factor = Big(priceFactor).div(valueFactor);
    return Big(valueEv).div(priceEv).times(factor).round(precision, rm).toFixed(precision);
  },
  getValueEv(balanceEv, priceEv, balanceFactor = 1e8, priceFactor = 1e4, valueFactor = 1e8, rm = 0) {
    if (balanceEv === 0) {
      return 0;
    }
    const factor = Big(valueFactor).div(priceFactor).div(balanceFactor);
    return Number(toString(Big(balanceEv).times(priceEv).times(factor)));
  },
  /**
   *
   * @param {*} balanceEv
   * @param {*} priceEv
   * @param {*} balanceFactor
   * @param {*} priceFactor
   * @param {*} precision 小数位数，0 到 1e+6（含）
   * @param {*} rm 舍入模式：0（向下）、1（半向上）、2（半偶数）或 3（向上）。
   * @returns
   */
  getValueRv(balanceEv, priceEv, balanceFactor = 1e8, priceFactor = 1e4, precision = 8, rm = 0) {
    if (balanceEv === 0) {
      return Big(0).toFixed(precision, rm);
    }
    const factor = Big(priceFactor).times(balanceFactor);
    return Big(balanceEv).times(priceEv).div(factor).round(precision, rm).toFixed(precision);
  },
};
